import Swiper, { Pagination } from "swiper";

import "swiper/css";
import "swiper/css/pagination";

export default class Fanclub {
    constructor() {
        this.$slider = document.querySelector(".js-howto4th-fanclub");

        if (!this.$slider) return;

        this.mediaQuery = window.matchMedia("(max-width: 768px)");
        this.handleMediaQuery = this.update.bind(this);
        this.handleResize = this.resize.bind(this);
        this.mediaQuery.addEventListener("change", this.handleMediaQuery);
        window.addEventListener("resize", this.handleResize);
        this.update();
    }

    update() {
        if (this.mediaQuery.matches) {
            this.init();
            return;
        }

        this.destroy();
    }

    init() {
        if (this.swiper) return;

        const $wrap = this.$slider.closest(".howto4th-fanclub__slider-wrap");

        this.swiper = new Swiper(this.$slider, {
            modules: [Pagination],
            slidesPerView: "auto",
            centeredSlides: true,
            spaceBetween: this.getSpaceBetween(),
            pagination: {
                el: $wrap.querySelector(".howto4th-fanclub__pagination"),
                clickable: true,
            },
        });
    }

    resize() {
        if (!this.swiper) return;

        this.swiper.params.spaceBetween = this.getSpaceBetween();
        this.swiper.update();
    }

    getSpaceBetween() {
        return (window.innerWidth / 390) * 16;
    }

    destroy() {
        if (!this.swiper) return;

        this.swiper.destroy(true, true);
        this.swiper = null;
    }
}
